import { RosterStar } from './roster-star/roaster-star';
import { Select } from '@wwe-portal/ui/components/select';

import { RosterLevelEnum } from '@wwe-portal/entities/roster.type';
import { FC } from 'react';
interface RosterStarSelectProps {
  starColor: RosterLevelEnum;
  value: string;
  onChange: (value: string) => void;
  availableStars?: string[];
}

/**
 * @deprecated Use `STAR_OPTIONS` instead. Kept for reference only.
 *
 * Format: `total_solid` — first number is the total star count, second is how
 * many of those are solid (filled). The remaining `total - solid` stars are
 * rendered as hollow (empty). Example: `6_3` = 6 stars total, 3 solid + 3 hollow.
 * Previously the dropdown exposed every intermediate solid/hollow combination;
 * we now only show fully-filled tiers (see `STAR_OPTIONS`).
 */
export const STAR_OPTIONS_DEPRECATED = [
  '1_1',
  '2_1',
  '2_2',
  '3_1',
  '3_2',
  '3_3',
  '4_1',
  '4_2',
  '4_3',
  '4_4',
  '5_1',
  '5_2',
  '5_3',
  '5_4',
  '5_5',
  '6_1',
  '6_2',
  '6_3',
  '6_4',
  '6_5',
  '6_6',
];

export const STAR_OPTIONS = ['1_1', '2_2', '3_3', '4_4', '5_5', '6_6', '7_7'];

/**
 * 7-star tier is currently Bronze-only. Backend returns placeholder data for
 * Silver/Gold `7_7`, so we filter it out at the UI level instead of relying
 * on stats-sheet presence.
 */
export const getAvailableStarOptions = (starColor: RosterLevelEnum) =>
  starColor === RosterLevelEnum.B
    ? STAR_OPTIONS
    : STAR_OPTIONS.filter((star) => star !== '7_7');

const parseStarOption = (option: string) => {
  const [total, rate] = option.split('_');
  const rateNumber = parseInt(rate ?? '0');
  const hollowStar = parseInt(total ?? '0') - rateNumber;
  return {
    rate: rateNumber,
    hollowStar,
  };
};

export const RosterStarSelect: FC<RosterStarSelectProps> = ({
  value,
  starColor,
  onChange,
  availableStars = STAR_OPTIONS,
}) => {
  return (
    <Select
      value={value}
      onChange={onChange}
      options={availableStars}
      renderItem={(item) => {
        const { rate, hollowStar } = parseStarOption(item);
        return (
          <RosterStar
            level={starColor}
            size={20}
            rate={rate}
            hollowStar={hollowStar}
            short={false}
          />
        );
      }}
      getKey={(item) => item}
    />
  );
};
